import { useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";

import { bgLinearGradient } from "@/app/types/ui";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { HeadingTwo } from "@/components/ui/typography/HeadingTwo";
import { Paragraph } from "@/components/ui/typography/Paragraph";

import codeSentImg from "@/assets/reset-password/code-send.svg";
import { CodeVerificationInput } from "@/components/reset-password/CodeVerificationInput";

export const Route = createFileRoute("/reset-password/code")({
  component: VerificationCode,
});

function VerificationCode() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center">
        <div className="flex flex-col gap-4 items-center">
          <img
            src={codeSentImg}
            alt={t("code_verification.img_alt")}
            className="w-3/5 h-auto"
          />
          <div className="flex flex-col gap-4 text-center mx-8 2xl:mx-28">
            <HeadingTwo>{t("code_verification.msg_title")}</HeadingTwo>
            <Paragraph>{t("code_verification.msg_text")}</Paragraph>
          </div>
        </div>
      </div>

      {/* Code validation Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500`}
      >
        <div className="flex flex-col my-auto">
          <div className="mx-auto mb-14">
            <MimiatHorizontalLogo />
          </div>
          <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto">
            <div className="flex flex-col gap-2 mb-4">
              <HeadingOne>{t("code_verification.title")}</HeadingOne>
              <Paragraph>{t("code_verification.subtitle")}</Paragraph>
            </div>
            <CodeVerificationInput type="reset" />
          </div>
        </div>
      </div>
    </div>
  );
}
